import ApiService from "../../ApiService";

const DetailsService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/bbs/details/loadscreenview", vo, successCallback, failureCallback);
    },
    loadMoreReply: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/bbs/details/loadmorereply", vo, successCallback, failureCallback);
    },
    loadMoreLike: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/bbs/details/loadmorelike", vo, successCallback, failureCallback);
    },
    addLike: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/bbs/details/addlike", vo, successCallback, failureCallback);
    },
    removeLike: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/bbs/details/removelike", vo, successCallback, failureCallback);
    },
    addFavourite: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/bbs/details/addfavourite", vo, successCallback, failureCallback);
    },
    removeFavourite: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/bbs/details/removefavourite", vo, successCallback, failureCallback);
    },
    addReply: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/bbs/details/addreply", vo, successCallback, failureCallback);
    },
    deleteReply: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/bbs/details/deletereply", vo, successCallback, failureCallback);
    },
};

export default DetailsService;
